import React, { FC } from 'react';
import { ContentfulRichTextHTML } from 'components/ContentfulRichTextHTML';
import { Styled } from './';
import { ITeroContractContentProps } from 'components/ITeroTermsConditionsModal/ITeroTermsConditionsModal.types';
import { isContractAvailableInCountry } from 'components/ITeroTermsConditionsModal/ITeroTermsConditionsModal.helper';
import { useI18n } from 'contexts/i18n';

// TODO: If you change the structure of contentful?.iTeroContract, make sure to update the related logic in ./ITeroRentalContract to keep them in sync.
// TODO: Make sure Lumina Go Beyond  proposal does not render other T&Cs except Lumina Go Beyond Rent Convert T&Cs.
const ITeroContract: FC<ITeroContractContentProps> = ({
  doctorProfile,
  contentful,
  isEPTPayment,
  isFuse25,
  isFuse45,
  isLuminaGoBeyondRentConvert,
  isSprintRay,
}) => {
  const i18n = useI18n();
  const isNotFuse = !isFuse25 && !isFuse45 && !isLuminaGoBeyondRentConvert;
  const isGenericTcUsAvailable =
    !isLuminaGoBeyondRentConvert &&
    isContractAvailableInCountry(
      doctorProfile?.country,
      contentful?.iTeroContract.genericTcUs.availableCountries
    );
  const isGenericTcCaAvailable =
    !isLuminaGoBeyondRentConvert &&
    isContractAvailableInCountry(
      doctorProfile?.country,
      contentful?.iTeroContract.genericTcCa.availableCountries
    );
  const isSprintRayAvailable = isSprintRay && !isLuminaGoBeyondRentConvert;

  return (
    <>
      {isNotFuse && (
        <>
          <ContentfulRichTextHTML
            document={contentful?.iTeroContract.luminaPcConfiguration.content}
          />
          <br />
          <br />
        </>
      )}

      <div>
        <Styled.Title>{i18n['ITERO PURCHASE TERMS AND CONDITIONS']}</Styled.Title>
      </div>

      {isLuminaGoBeyondRentConvert && (
        <ContentfulRichTextHTML
          document={contentful?.iTeroContract.luminaGoBeyondRentConvert.content}
        />
      )}

      {isGenericTcUsAvailable && (
        <ContentfulRichTextHTML
          document={contentful?.iTeroContract.genericTcUs.content}
        />
      )}

      {isGenericTcCaAvailable && (
        <ContentfulRichTextHTML
          document={contentful?.iTeroContract.genericTcCa.content}
        />
      )}

      {/* if Fuse 25, or Fuse 45 rendered with Lumina Go Beyond proposal, it is considered a configuration error */}
      {
        // Fuse 25 Terms and Conditions for US related countries
        isFuse25 &&
          isContractAvailableInCountry(
            doctorProfile?.country,
            contentful?.iTeroContract.fuse25TcUs.availableCountries
          ) && (
            <ContentfulRichTextHTML
              document={contentful?.iTeroContract.fuse25TcUs.content}
            />
          )
      }
      {
        // Fuse 25 Terms and Conditions for CA
        isFuse25 &&
          isContractAvailableInCountry(
            doctorProfile?.country,
            contentful?.iTeroContract.fuse25TcCa.availableCountries
          ) && (
            <ContentfulRichTextHTML
              document={contentful?.iTeroContract.fuse25TcCa.content}
            />
          )
      }
      {
        // Fuse 45 Terms and Conditions for US related countries
        isFuse45 &&
          isContractAvailableInCountry(
            doctorProfile?.country,
            contentful?.iTeroContract.fuse45TcUs.availableCountries
          ) && (
            <ContentfulRichTextHTML
              document={contentful?.iTeroContract.fuse45TcUs.content}
            />
          )
      }
      {
        // Fuse 45 Terms and Conditions for CA
        isFuse45 &&
          isContractAvailableInCountry(
            doctorProfile?.country,
            contentful?.iTeroContract.fuse45TcCa.availableCountries
          ) && (
            <ContentfulRichTextHTML
              document={contentful?.iTeroContract.fuse45TcCa.content}
            />
          )
      }
      {isEPTPayment && (
        <>
          <br />
          <div>
            <Styled.Title>{i18n['Extended Payment Terms & Conditions']}</Styled.Title>
          </div>
          <br />
        </>
      )}
      {
        // Extended Payment Terms and Conditions for US related countries
        isEPTPayment &&
          isContractAvailableInCountry(
            doctorProfile?.country,
            contentful?.iTeroContract.eptTcUs.availableCountries
          ) && (
            <ContentfulRichTextHTML
              document={contentful?.iTeroContract.eptTcUs.content}
            />
          )
      }
      {
        // Extended Payment Terms and Conditions for CA
        isEPTPayment &&
          isContractAvailableInCountry(
            doctorProfile?.country,
            contentful?.iTeroContract.eptTcCa.availableCountries
          ) && (
            <ContentfulRichTextHTML
              document={contentful?.iTeroContract.eptTcCa.content}
            />
          )
      }
      {
        // SprintRay Terms and Conditions
        isSprintRayAvailable && (
          <ContentfulRichTextHTML
            document={contentful?.iTeroContract.sprintRay.content}
          />
        )
      }
      {isContractAvailableInCountry(
        doctorProfile?.country,
        contentful?.iTeroContract.californiaDeclaration.availableCountries
      ) && (
        <p style={{ border: '5px solid black', padding: 10 }}>
          <ContentfulRichTextHTML
            document={contentful?.iTeroContract.californiaDeclaration.content}
          />
        </p>
      )}
    </>
  );
};

export default ITeroContract;
